<template>
  <div class="recovery-page">
    <div class="header"></div>
    <password-recovery v-if="!isSubmitted" @submitted="showSuccessMessage" />
    <success-message v-if="isSubmitted">
      <h3>You successfully reset your password. You can sign in now.</h3>
      <v-btn x-medium color="#f0b323" @click="login">Sign In</v-btn>
    </success-message>
  </div>
</template>

<script>
import passwordRecovery from '@/components/auth/password-recovery'
import SuccessMessage from '@/components/submission/success-message'

export default {
  name: 'recovery',
  components: {
    passwordRecovery,
    SuccessMessage
  },
  data () {
    return {
      isSubmitted: false
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters['user/isLoggedIn']
    }
  },
  watch: {
    isLoggedIn (v) {
      if (v) {
        this.$router.push({ name: 'deals' })
      }
    }
  },
  methods: {
    showSuccessMessage () {
      this.isSubmitted = true
      this.$ga.page({
        page: this.$route.path + '/reset-password/success',
        title: 'Success reset password'
      })
    },
    login () {
      this.$store.dispatch('modals/showModal', 'login')
    }
  }
}
</script>

<style lang="scss" scoped>
.recovery-page {
  position: relative;
  padding-top: 100px;
  .header {
    height: 585px;
    background-color: #001D27;
    width: 100%;
    position: absolute;
    top: 0;
  }
}
</style>
